module.exports = __webpack_public_path__ + "img/magnifying_glass_icon_172355.eef80e43_1.0.18.png";